

<agm-map
[latitude]="center.lat"
 [longitude]="center.lng"
 [zoom]="zoom"
 [disableDefaultUI]="false"
 >
  <ng-container   *ngFor="let branch of branches">

  <agm-marker
  *ngIf="branch.position!=null"
  animation="DROP"
  [latitude]="branch.position.lat"
  [longitude]="branch.position.lng"
  [iconUrl]="{url:branch.icon,anchor : {x:branch.position.lat, y:branch.position.lng}  }"
  (mouseOver)="onMarkerMouseOver(branch)"
  (mouseOut)="onMarkerMouseOut(branch)"
  (markerClick)="onMarkerClicked(infowindow)">
  <agm-info-window [latitude]="branch.position.lat"
  [longitude]="branch.position.lng"  [disableAutoPan]="false" [isOpen]="isInfoWindowOpen(branch.id)"   #infowindow >
  <div class="map-pin-popout text-center"> 
    <p class="popout-location mb-2"><fa-icon class="mr-1" [icon]="faMapMarkerAlt"></fa-icon><strong>{{ 'SC_Location' | translate }}</strong> <br />
     {{branch.locationName}}</p>
    <h5 class="popout-name">{{branch.name}}</h5>
    <div class="popout-price">
      <p class="mb-0">{{ 'PricesFrom' | translate }}</p>
      <span>{{branch.price | number}} {{currency}}</span>
      <p>{{ 'For' | translate }} {{branch.durationUnitName}} </p>
    </div>
    <p class="show-all-cars mt-4" *ngIf="searchModel.AgencyID==null"><a (click)="onShowAllCarsClicked(branch)"> {{ 'showAllCars' | translate }} ({{branch.totalCars}})</a></p>

  </div>
  </agm-info-window>


  </agm-marker>
  
</ng-container>

</agm-map>
